import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCommonConfig } from "../../../../../redux/actions";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
  dotNumberValidation,
  dotNumberBlurValidation,
  withDotValidation,
} from "../../../../../helpers/global_helper";
import ConfirmBetDeskonPopup from "../../../../Popups/ConfirmBetDeskonPopup";
import BetSuccessPopup from "../../../../Popups/BetSuccessPopup";
import ErrorPopup from "../../../../Popups/ErrorPopup";
import ErrorInnerPopup from "../../../../Popups/ErrorInnerPopup";
import CancelledBetDeskonPopup from "../../../../Popups/CancelledBetDeskonPopup";
import { withTranslation } from "react-i18next";
import { getUserBalance } from "../../../../../redux/actions";
import GameClosedPopup from "../../GameClosedPopup";
import MarketClose from "../../MarketClose";
import { formatPricewithdecimal } from "../../../../NumberFormat";
import CommonBetHeader from "../../CommonBetHeader";

const Dasar = (props) => {
  const dispatch = useDispatch();
  const device = useSelector((state) => state.CommonConfig.device_type);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const [rowsToShow, setRowsToShow] = useState(4);
  const [values, setValues] = useState({ table1: [], table2: [] });
  const [belliValues, setBelliValues] = useState({ table1: {}, table2: {} });
  const [radioValues, setRadioValues] = useState({ table1: {}, table2: {} });
  const [showCancelledPopup, setShowCanclledPopup] = useState(false);
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const [ganjilValue, setGanjilValue] = useState("");
  const [genapValue, setGenapValue] = useState("");
  const [besarValue, setBesarValue] = useState("");
  const [kecilValue, setKecilValue] = useState("");
  const initialMoData = [
    { gameName: "" },
    { gameName: "" },
    { gameName: "" },
    { gameName: "" },
  ];
  const [moData, setMoData] = useState(initialMoData);

  const [reqData, setReqData] = useState({
    gameId: null,
    gameType: "dasar",
    dataangka: [],
    action: "process",
    betTogelAuth: "betTogelAuth",
  });

  const [reqDataMo, setReqDataMo] = useState({
    gameId: gameId,
    gameType: "dasar",
    dataangka: [],
    action: "process",
    betTogelAuth: "betTogelAuth",
  });
  const belliRefs = useRef([]);
  const ganjilInputRef = useRef(null);
  const genapInputRef = useRef(null);
  const besarInputRef = useRef(null);
  const kecilInputRef = useRef(null);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [SubmitRespData, setSubmitRespData] = useState([]);
  const [successPopup, setSuccessPopup] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    dispatch(setCommonConfig({ key: "gameType", value: "dasar" }));
  }, []);

  useEffect(() => {
    generateDataAngka();
  }, [belliValues, radioValues]);

  // const handleInputChange = (e, rowIndex, columnName, table = null) => {
  //   const { name, value } = e.target;
  //   if (columnName === "Belli") {
  //     let minValue = null;
  //     let maxValue = null;
  //     minValue = betDiscount.showMin / 1000;
  //     maxValue = betDiscount.showMax / 1000;
  //     if (!/^\d*([.,]\d?)?$/.test(value)) {
  //       clearBetValue(rowIndex, table, name);
  //     } else if (value < minValue) {
  //       setShowErrorPopup(true);
  //       setErrorMessage("Minimum bet is 1");
  //       clearBetValue(rowIndex, table, name)
  //     } else if (value > maxValue) {
  //       setShowErrorPopup(true);
  //       setErrorMessage("Your nominal bet exceeds the maximum limit.");
  //       clearBetValue(rowIndex, table, name);
  //     } else {
  //       setBelliValues((prevState) => {
  //         const newValues = { ...prevState };
  //         if (table) {
  //           if (!newValues[table]) newValues[table] = {};
  //           newValues[table][name] = value;
  //         } else {
  //           newValues[`belli-${rowIndex}`] = value;
  //         }
  //         return newValues;
  //       });
  //     }
  //   } else if (columnName === "Radio" || columnName === "Radio1") {
  //     setValues((prevState) => {
  //       const newValues = { ...prevState };
  //       if (table) {
  //         if (!newValues[table]) newValues[table] = [];
  //         newValues[table][rowIndex] = value;
  //       } else {
  //         newValues[rowIndex] = value;
  //       }
  //       return newValues;
  //     });
  //     setRadioValues((prevState) => {
  //       const newValues = { ...prevState };
  //       if (table) {
  //         if (!newValues[table]) newValues[table] = {};
  //         newValues[table][name] = value;
  //       } else {
  //         newValues[`select-${rowIndex}`] = value;
  //       }
  //       return newValues;
  //     });
  //   }

  //   setMoData(prevState => {
  //     const updatedMoData = [...prevState];
  //     updatedMoData[rowIndex].gameName = value;
  //     return updatedMoData;
  //   });

  // };

  const handleInputChange = (e, rowIndex, columnName, table = null) => {
    const { name, value } = e.target;

    if (columnName === "Belli") {
      let minValue = betDiscount.showMin / 1000;
      let maxValue = betDiscount.showMax / 1000;

      let regex = '';
      if (String(betDiscount.showMin).length === 3) {
        regex = /^\d*([.,]\d?)?$/;
      } else {
        regex = /^\d*$/;
        value = withDotValidation(value);
      }
      if (!regex.test(value)) {
        clearBetValue(rowIndex, table, name);
      }
      // else if (value < minValue) {
      //   setShowErrorPopup(true);
      //   setErrorMessage("Minimum bet is 1");
      //   clearBetValue(rowIndex, table, name);
      // } 
      else if (value > maxValue) {
        setShowErrorPopup(true);
        setErrorMessage(props.t('you_have_reached_max_bet_value'));
        clearBetValue(rowIndex, table, name);
      } else {
        setBelliValues((prevState) => {
          const newValues = { ...prevState };
          if (table) {
            if (!newValues[table]) newValues[table] = {};
            newValues[table][name] = value;
          } else {
            newValues[`belli-${rowIndex}`] = value;
          }
          return newValues;
        });
      }
    } else if (columnName === "Radio" || columnName === "Radio1") {
      setValues((prevState) => {
        const newValues = { ...prevState };
        if (table) {
          if (!newValues[table]) newValues[table] = [];
          newValues[table][rowIndex] = value;
        } else {
          newValues[rowIndex] = value;
        }
        return newValues;
      });

      setRadioValues((prevState) => {
        const newValues = { ...prevState };
        if (table) {
          if (!newValues[table]) newValues[table] = {};
          newValues[table][name] = value;
        } else {
          newValues[`select-${rowIndex}`] = value;
        }
        return newValues;
      });

      // Update moData only for Radio/Radio1
      setMoData((prevState) => {
        const updatedMoData = [...prevState];
        updatedMoData[rowIndex].gameName = value;
        return updatedMoData;
      });
    }
  };

  const calculateTotal = (value, name) => {
    const betAmount = value * betDiscount.showMultiple;


    if (betAmount === 0) {
      setReqDataMo((prevState) => {
        const updatedData = prevState.dataangka.filter((item) => item[0] !== name);

        let totalGanjil = 0;
        let totalGenap = 0;
        let totalBesar = 0;
        let totalKecil = 0;

        updatedData.forEach((item) => {
          if (item[0] === "ganjil") {
            if (Math.sign(betDiscount.keiganjil) === -1) {
              totalGanjil += item[1] + ((item[1] * (Math.abs(betDiscount.keiganjil) / 100))) - ((item[1] + (item[1] * (Math.abs(betDiscount.keiganjil) / 100))) * (betDiscount.showDisc / 100));
            } else {
              totalGanjil += item[1] - (item[1] * (betDiscount.showDisc / 100));
            }
          } else if (item[0] === "genap") {
            if (Math.sign(betDiscount.keigenap) === -1) {
              totalGenap += item[1] + ((item[1] * (Math.abs(betDiscount.keigenap) / 100))) - ((item[1] + (item[1] * (Math.abs(betDiscount.keigenap) / 100))) * (betDiscount.showDisc / 100));
            } else {
              totalGenap += item[1] - (item[1] * (betDiscount.showDisc / 100));
            }
          } else if (item[0] === "besar") {
            if (Math.sign(betDiscount.keibesar) === -1) {
              totalBesar += item[1] + ((item[1] * (Math.abs(betDiscount.keibesar) / 100))) - ((item[1] + (item[1] * (Math.abs(betDiscount.keibesar) / 100))) * (betDiscount.showDisc / 100));
            } else {
              totalBesar += item[1] - (item[1] * (betDiscount.showDisc / 100));
            }
          } else if (item[0] === "kecil") {
            if (Math.sign(betDiscount.keikecil) === -1) {
              totalKecil += item[1] + ((item[1] * (Math.abs(betDiscount.keikecil) / 100))) - ((item[1] + (item[1] * (Math.abs(betDiscount.keikecil) / 100))) * (betDiscount.showDisc / 100));
            } else {
              totalKecil += item[1] - (item[1] * (betDiscount.showDisc / 100));
            }
          }
        });

        const totalAmount = parseFloat((totalGanjil + totalGenap + totalBesar + totalKecil).toFixed(2));
        setTotalAmount(totalAmount);
        return {
          ...prevState,
          dataangka: updatedData,
        };
      });
    } else {
      setReqDataMo((prevState) => {
        const updatedData = prevState.dataangka.filter((item) => item[0] !== name);
        const resultArray = [name, betAmount, "success"];
        const newData = [...updatedData, resultArray];

        let totalGanjil = 0;
        let totalGenap = 0;
        let totalBesar = 0;
        let totalKecil = 0;


        newData.forEach((item) => {
          if (item[0] === "ganjil") {
            if (Math.sign(betDiscount.keiganjil) === -1) {
              totalGanjil += item[1] + ((item[1] * (Math.abs(betDiscount.keiganjil) / 100))) - ((item[1] + (item[1] * (Math.abs(betDiscount.keiganjil) / 100))) * (betDiscount.showDisc / 100));
            } else {
              totalGanjil += item[1] - (item[1] * (betDiscount.showDisc / 100));
            }
          } else if (item[0] === "genap") {
            if (Math.sign(betDiscount.keigenap) === -1) {
              totalGenap += item[1] + ((item[1] * (Math.abs(betDiscount.keigenap) / 100))) - ((item[1] + (item[1] * (Math.abs(betDiscount.keigenap) / 100))) * (betDiscount.showDisc / 100));
            } else {
              totalGenap += item[1] - (item[1] * (betDiscount.showDisc / 100));
            }
          } else if (item[0] === "besar") {
            if (Math.sign(betDiscount.keibesar) === -1) {
              totalBesar += item[1] + ((item[1] * (Math.abs(betDiscount.keibesar) / 100))) - ((item[1] + (item[1] * (Math.abs(betDiscount.keibesar) / 100))) * (betDiscount.showDisc / 100));
            } else {
              totalBesar += item[1] - (item[1] * (betDiscount.showDisc / 100));
            }
          } else if (item[0] === "kecil") {
            if (Math.sign(betDiscount.keikecil) === -1) {
              totalKecil += item[1] + ((item[1] * (Math.abs(betDiscount.keikecil) / 100))) - ((item[1] + (item[1] * (Math.abs(betDiscount.keikecil) / 100))) * (betDiscount.showDisc / 100));
            } else {
              totalKecil += item[1] - (item[1] * (betDiscount.showDisc / 100));
            }
          }
        });

        const totalAmount = parseFloat((totalGanjil + totalGenap + totalBesar + totalKecil).toFixed(2));
        setTotalAmount(totalAmount);

        return {
          ...prevState,
          dataangka: newData,
        };
      });
    }
  };

  const handleInputBlur = (e, columnName, name) => {
    let { value } = e.target;
    value = value.replace(',', '.');
    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberBlurValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }
    e.target.value = value;
    handleInputChange1(e, columnName, name);
  }

  // Function to handle input change
  const handleInputChange1 = (e, columnName, name) => {
    let { value } = e.target;
    value = value.replace(',', '.');
    let minValue = betDiscount.showMin / 1000;
    let maxValue = betDiscount.showMax / 1000;

    let regex = '';
    if (String(betDiscount.showMin).length === 3) {
      regex = /^\d*([.,]\d?)?$/;
      value = dotNumberValidation(value);
    } else {
      regex = /^\d*$/;
      value = withDotValidation(value);
    }

    if (!regex.test(value)) {
      e.target.value = value.slice(0, -1);
    }
    // else if (value < minValue && value) {
    //   setShowErrorPopup(true);
    //   setErrorMessage(props.t('minimum_bet_is_1'));
    //   ganjilInputRef.current.value = "";
    //   genapInputRef.current.value = "";
    //   besarInputRef.current.value = "";
    //   kecilInputRef.current.value = "";
    // } 
    else if (value > maxValue) {
      setShowErrorPopup(true);
      setErrorMessage("You have reached the max bet value");
      e.target.value = value.slice(0, -1);
    } else {
      setShowErrorPopup(false);
      if (name == 'ganjil') {
        setGanjilValue(value);
      } else if (name === "genap") {
        setGenapValue(value);
      } else if (name === "besar") {
        setBesarValue(value);
      } else if (name === "kecil") {
        setKecilValue(value);
      }
      calculateTotal(value, name);
    }
  };

  const clearBetValue = (rowIndex, table, name) => {
    setBelliValues((prevState) => {
      const newValues = { ...prevState };
      if (table) {
        if (newValues[table]) {
          newValues[table][name] = "";
        }
      } else {
        newValues[`belli-${rowIndex}`] = "";
      }
      return newValues;
    });
    if (belliRefs.current[`${table}-${rowIndex}`]) {
      belliRefs.current[`${table}-${rowIndex}`].value = "";
    } else if (belliRefs.current[`belli-${rowIndex}`]) {
      belliRefs.current[`belli-${rowIndex}`].value = "";
    }
  };

  const generateDataAngka = () => {
    let newDataAngka = Array.from({ length: rowsToShow }, (_, index) => {
      const key = `ganjilGenap-${index}`;
      const radioValue =
        (radioValues.table1 && radioValues.table1[key]) ||
        radioValues[`select-${index}`] ||
        "";
      const belliValue =
        ((belliValues.table1 && belliValues.table1[`belli-${index}`]) ||
          belliValues[`belli-${index}`] ||
          0) * betDiscount.showMultiple;
      return [
        radioValue,
        belliValue,
        radioValue && belliValue ? "success" : null,
      ];
    });

    let newDataAngka1 = Array.from({ length: rowsToShow }, (_, index) => {
      const key = `besarKecil-${index}`;
      const radioValue = (radioValues.table2 && radioValues.table2[key]) || "";
      const belliValue =
        ((belliValues.table2 && belliValues.table2[`belli-${index}`]) || 0) *
        betDiscount.showMultiple;
      return [
        radioValue,
        belliValue,
        radioValue && belliValue ? "success" : null,
      ];
    });

    const filteredDataAngka = newDataAngka.filter(
      (item) => item[0] && item[1] > 0
    );
    const filteredDataAngka1 = newDataAngka1.filter(
      (item) => item[0] && item[1] > 0
    );

    setReqData((prevState) => ({
      ...prevState,
      gameId: gameId,
      dataangka: [...filteredDataAngka, ...filteredDataAngka1],
    }));
  };

  const validateForm = () => {
    const isTable1Valid =
      Object.values(radioValues.table1 || {}).some((value) => value !== "") &&
      Object.values(belliValues.table1 || {}).some((value) => value !== "");
    const isTable2Valid =
      Object.values(radioValues.table2 || {}).some((value) => value !== "") &&
      Object.values(belliValues.table2 || {}).some((value) => value !== "");
    const isSelectValid =
      Object.keys(radioValues).some(
        (key) => key.startsWith("select") && radioValues[key] !== ""
      ) &&
      Object.keys(belliValues).some(
        (key) => key.startsWith("belli") && belliValues[key] !== ""
      );

    if (!isTable1Valid && !isTable2Valid && !isSelectValid) {
      setErrorMessage(
        "Each table must have at least one row selected with a radio button and a beli amount."
      );
      setShowErrorPopup(true);
      return false;
    }
    return true;
  };

  const submitProcess = (event) => {
    // const isEmptyRadioValuesTbl1 =
    //   Object.keys(radioValues["table1"] || {}).length === 0;
    // const isEmptyBelliValuesTbl1 =
    //   Object.keys(belliValues["table1"] || {}).length === 0;
    // const isEmptyRadioValuesTbl2 =
    //   Object.keys(radioValues["table2"] || {}).length === 0;
    // const isEmptyBelliValuesTbl2 =
    //   Object.keys(belliValues["table2"] || {}).length === 0;
    // const isEmptySelect = Object.keys(radioValues).every(
    //   (key) => !key.startsWith("select") || radioValues[key] === ""
    // );
    // const isEmptyBelliSelect = Object.keys(belliValues).every(
    //   (key) => !key.startsWith("belli") || belliValues[key] === ""
    // );

    // if (device == 'Desktop') {
    //   if (
    //     (isEmptyRadioValuesTbl1 && isEmptyRadioValuesTbl2 && isEmptySelect) ||
    //     (isEmptyBelliValuesTbl1 && isEmptyBelliValuesTbl2 && isEmptyBelliSelect)
    //   ) {
    //     setErrorMessage(
    //       "No bets are placed. Please fill in your bet and betting amount."
    //     );
    //     setShowErrorPopup(true);
    //   } else if (validateForm()) {
    //     setShowConfirmationPopup(true);
    //   }
    // } else {
    setShowConfirmationPopup(true);
    // }
  };
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const submitProcessOk = () => {
    setShowConfirmationPopup(false);
    // let mainData = '';
    // if (device == 'Mobile') {
    //   mainData = reqDataMo;
    // } else {
    //   mainData = reqData;
    // }
    makeAjax(url.TOGEL_API.processAltTogel, reqDataMo).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
        if (response.code !== "validation_error") {
          setErrorMessage(props.t(response.code))
          setShowErrorPopup(true);
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      allDataReset();
      setSubmitRespData((prevData) => [...prevData, response.data]);
      dispatch(getUserBalance());
      setGanjilValue('');
      setGenapValue('');
      setBesarValue('');
      setKecilValue('');
      setSuccessPopup(true);
    });
  };

  useEffect(() => {
    allDataReset();
  }, [gameId]);

  const allDataReset = () => {

    setValues({ table1: [], table2: [] });
    setBelliValues({ table1: {}, table2: {} });
    setRadioValues({ table1: {}, table2: {} });
    setMoData(initialMoData);
    setGanjilValue("");
    setGenapValue("");
    setBesarValue("");
    setKecilValue("");
    setReqData({
      gameId: null,
      gameType: "dasar",
      dataangka: [],
      action: "process",
      betTogelAuth: "betTogelAuth",
    });
    setReqDataMo({
      gameId: gameId,
      gameType: "dasar",
      dataangka: [],
      action: "process",
      betTogelAuth: "betTogelAuth",
    });
    const beliInputs = document.querySelectorAll('input[name^="belli-"]');
    beliInputs.forEach((input) => {
      input.disabled = true;
      input.value = ""; // Reset the value
    });
    setTotalAmount(0);
    ganjilInputRef.current.value = "";
    genapInputRef.current.value = "";
    besarInputRef.current.value = "";
    kecilInputRef.current.value = "";
  };

  const rowDataReset = (rowIndex) => {
    const selectElement = document.querySelector(
      `select[name="guess-${rowIndex}"]`
    );
    if (selectElement) {
      selectElement.value = "";
    }
    if (belliRefs.current[rowIndex]) {
      belliRefs.current[rowIndex].value = "";
    }
    setMoData((prevState) => {
      const newState = [...prevState];
      newState[rowIndex].gameName = ""; // Reset gameName to empty
      return newState;
    });
    setValues((prevState) => {
      const newState = { ...prevState };
      newState[rowIndex] = "";
      return newState;
    });
    setRadioValues((prevState) => {
      const newState = { ...prevState };
      delete newState[`select-${rowIndex}`];
      return newState;
    });
    setBelliValues((prevState) => {
      const newState = { ...prevState };
      delete newState[`belli-${rowIndex}`];
      return newState;
    });
  };

  const handleClose = () => {
    setSuccessPopup(false);
    setSubmitRespData("");
  };

  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCanclledPopup(true);
  };

  return (
    <>
      <div className="fiftyfifty_wrapper">
        {showGameClose ? (
          <GameClosedPopup />
        ) : showMarketClose ? (
          <MarketClose />
        ) : (
          <>
            {/* {device === "Desktop" ? (
              <>
                <div className="fiftyfifty_heading">
                  <h1>
                    {props.t("odd")}/{props.t("even")}
                  </h1>
                </div>
                <div className="fiftyfifty_container">
                  <table>
                    <thead>
                      <tr>
                        <th>{props.t("no.")}</th>
                        <th>{props.t("guess")}</th>
                        <th>{props.t("Kei")}</th>
                        <th>
                          {props.t("buy")}{" "}
                          <span className="small_input">1=1000</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {[...Array(rowsToShow)].map((_, index) => (
                        <tr
                          key={index}
                          className={index % 2 === 0 ? "even-row" : "odd-row"}
                        >
                          <td>{index + 1}</td>
                          <td className="input" valign="middle">
                            <input
                              type="radio"
                              name={`ganjilGenap-${index}`}
                              value="ganjil"
                              checked={values.table1[index] === "ganjil"}
                              onChange={(e) =>
                                handleInputChange(e, index, "Radio", "table1")
                              }
                            />
                            &nbsp; {props.t("odd")} &nbsp; &nbsp;
                            <input
                              type="radio"
                              name={`ganjilGenap-${index}`}
                              value="genap"
                              checked={values.table1[index] === "genap"}
                              onChange={(e) =>
                                handleInputChange(e, index, "Radio", "table1")
                              }
                            />
                            &nbsp;{props.t("even")}
                          </td>

                          <td>
                            {betDiscount["keiganjil"]
                              ? betDiscount["keiganjil"] + "%"
                              : ""}{" "}
                            |{" "}
                            {betDiscount["keigenap"]
                              ? betDiscount["keigenap"] + "%"
                              : ""}
                          </td>
                          <td className="inputs">
                            <input
                              type="text"
                              placeholder="1 = 1,000 IDR"
                              name={`belli-${index}`}
                              onChange={(e) =>
                                handleInputChange(e, index, "Belli", "table1")
                              }
                              disabled={!values.table1[index]}
                              ref={(el) =>
                                (belliRefs.current[`table1-${index}`] = el)
                              }
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div
                  className="fiftyfifty_heading"
                  style={{ marginTop: "10px" }}
                >
                  <h1>
                    {props.t("big")}/{props.t("small")}
                  </h1>
                </div>
                <div className="fiftyfifty_container">
                  <table>
                    <thead>
                      <tr>
                        <th>{props.t("no.")}</th>
                        <th>{props.t("guess")}</th>
                        <th>{props.t("Kei")}</th>
                        <th>
                          {props.t("buy")}{" "}
                          <span className="small_input">1=1000</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {[...Array(rowsToShow)].map((_, index) => (
                        <tr
                          key={index}
                          className={index % 2 === 0 ? "even-row" : "odd-row"}
                        >
                          <td>{index + 1}</td>
                          <td className="input" valign="middle">
                            <input
                              type="radio"
                              value="besar"
                              name={`besarKecil-${index}`}
                              checked={values.table2[index] === "besar"}
                              onChange={(e) =>
                                handleInputChange(e, index, "Radio1", "table2")
                              }
                            />
                            &nbsp; {props.t("big")} &nbsp; &nbsp;
                            <input
                              type="radio"
                              name={`besarKecil-${index}`}
                              value="kecil"
                              checked={values.table2[index] === "kecil"}
                              onChange={(e) =>
                                handleInputChange(e, index, "Radio1", "table2")
                              }
                            />
                            &nbsp;{props.t("small")}
                          </td>

                          <td>
                            {betDiscount["keibesar"]}% |{" "}
                            {betDiscount["keikecil"]}%
                          </td>
                          <td className="inputs">
                            <input
                              type="text"
                              placeholder="1 = 1,000 IDR"
                              name={`belli-${index}`}
                              onChange={(e) =>
                                handleInputChange(e, index, "Belli", "table2")
                              }
                              disabled={!values.table2[index]}
                              ref={(el) =>
                                (belliRefs.current[`table2-${index}`] = el)
                              }
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            ) : (
              <> */}
            <div className="container desar">
              {/* <table>
                    <thead>
                      <tr>
                        <th>{props.t("no.")}</th>
                        <th>{props.t("guess")}</th>
                        <th>{props.t("Kei")}</th>
                        <th>
                          {props.t("buy")}{" "}
                          <span className="small_input">1=1000</span>
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {[...Array(rowsToShow)].map((_, index) => (
                        <tr
                          key={index}
                          className={index % 2 === 0 ? "even-row" : "odd-row"}
                        >
                          <td>{index + 1}</td>
                          <td className="inputs">
                            <select
                              name={`guess-${index}`}
                              onChange={(e) =>
                                handleInputChange(e, index, "Radio")
                              }
                             
                              value={radioValues[`select-${index}`] || ""}
                            >
                              <option value=""></option>
                              <option value="ganjil">{props.t("odd")}</option>
                              <option value="genap">{props.t("even")}</option>
                              <option value="besar">{props.t("big")}</option>
                              <option value="kecil">{props.t("small")}</option>
                            </select>
                          </td>
                          
                          <td>
                            <input
                              style={{ width: "40px" }}
                              type="text"
                              
                              value={
                                moData[index].gameName === "ganjil"
                                  ? `${betDiscount.keiganjil
                                    ? betDiscount.keiganjil + "%"
                                    : ""
                                  }`
                                  : moData[index].gameName === "genap"
                                    ? `${betDiscount.keigenap
                                      ? betDiscount.keigenap + "%"
                                      : ""
                                    }`
                                    : moData[index].gameName === "besar"
                                      ? `${betDiscount.keibesar
                                        ? betDiscount.keibesar + "%"
                                        : ""
                                      }`
                                      : moData[index].gameName === "kecil"
                                        ? `${betDiscount.keikecil
                                          ? betDiscount.keikecil + "%"
                                          : ""
                                        }`
                                        : `${betDiscount.keiganjil
                                          ? betDiscount.keiganjil + "%"
                                          : ""
                                        }`
                              }
                              readOnly
                            />
                          </td>
                          <td className="inputs">
                            <input
                              type="text"
                              name={`belli-${index}`}
                              placeholder="1 = 1,000 IDR"
                              inputMode="numeric"
                              pattern="[0-9]*"
                              onChange={(e) =>
                                handleInputChange(e, index, "Belli")
                              }
                              disabled={!radioValues[`select-${index}`]}
                              ref={(el) => (belliRefs.current[index] = el)}
                              value={belliValues[`belli-${index}`] || ""}
                            />
                          </td>
                          <td>
                            <button
                              className="reset-button"
                              onClick={(e) => rowDataReset(index)}
                            >
                              reset
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table> */}
              <div className="tengah-table">
                <CommonBetHeader rowsToShow={null} handleRowsToShowChange={null} bbPayAmount={0} totalBetAmount={totalAmount} gameName="tengahDasar" />
                {/* <div className="buy-data">Buy it x 1000</div> */}
                <div className="edge-data">
                  <div className="edge">
                    <div className="text">{props.t("odd")}</div>
                    <div>Kei:{betDiscount["keiganjil"]}%</div>
                  </div>
                  <div className="central">
                    <div className="text">{props.t("even")}</div>
                    <div>Kei:{betDiscount["keigenap"]}%</div>
                  </div>
                </div>

                <div className="tengah-input">
                  <div className="input-text">
                    <input
                      type="text"
                      name="ganjil"
                      value={ganjilValue}
                      placeholder="Bet"
                      inputMode="decimal"
                      pattern="[0-9]*[.,]?[0-9]**"
                      ref={ganjilInputRef}
                      onChange={(e) =>
                        handleInputChange1(e, "Belli", 'ganjil')
                      }
                      onBlur={(e) =>
                        handleInputBlur(e, "Belli", 'ganjil')
                      }
                    />
                  </div>
                  <div className="input-text">
                    <input
                      type="text"
                      name="genap"
                      value={genapValue}
                      placeholder="Bet"
                      inputMode="decimal"
                      pattern="[0-9]*[.,]?[0-9]**"
                      ref={genapInputRef}
                      onChange={(e) =>
                        handleInputChange1(e, "Belli", 'genap')
                      }
                      onBlur={(e) =>
                        handleInputBlur(e, "Belli", 'genap')
                      }
                    />
                  </div>
                </div>

                <div className="edge-data">
                  <div className="edge">
                    <div className="text">{props.t("big")}</div>
                    <div>Kei:{betDiscount["keibesar"]}%</div>
                  </div>
                  <div className="central">
                    <div className="text">{props.t("small")}</div>
                    <div>Kei:{betDiscount["keikecil"]}%</div>
                  </div>
                </div>

                <div className="tengah-input">
                  <div className="input-text">
                    <input
                      type="text"
                      name="besar"
                      value={besarValue}
                      placeholder="Bet"
                      inputMode="decimal"
                      pattern="[0-9]*[.,]?[0-9]**"
                      ref={besarInputRef}
                      onChange={(e) =>
                        handleInputChange1(e, "Belli", 'besar')
                      }
                      onBlur={(e) =>
                        handleInputBlur(e, "Belli", 'besar')
                      }
                    />
                  </div>
                  <div className="input-text">
                    <input
                      type="text"
                      name="kecil"
                      value={kecilValue}
                      placeholder="Bet"
                      inputMode="decimal"
                      pattern="[0-9]*[.,]?[0-9]**"
                      ref={kecilInputRef}
                      onChange={(e) =>
                        handleInputChange1(e, "Belli", 'kecil')
                      }
                      onBlur={(e) =>
                        handleInputBlur(e, "Belli", 'kecil')
                      }
                    />
                  </div>
                </div>

              </div>
            </div>



            <div className="last_div">
              <div className="left_div">
                <p>{props.t("tengah_dasar_dasar_text")}</p>
              </div>
              <div className="right_div">
                <ul className="button-list">
                  <li>
                    <button className="reset" onClick={allDataReset}>
                      {props.t("reset")}
                    </button>
                  </li>
                  <li>
                    <button className="submit" onClick={submitProcess}>
                      {props.t("submit")}
                    </button>
                  </li>
                </ul>
              </div>

              {showConfirmationPopup && (
                <ConfirmBetDeskonPopup
                  onClose={hanldeConfirmationPopupClose}
                  submitProcessOk={submitProcessOk}
                />
              )}
              {successPopup && (
                <div className="popup-overlay ">
                  <BetSuccessPopup
                    response={SubmitRespData}
                    onClose={handleClose}
                  />
                </div>
              )}
              {
                /*---error popup --*/
                showErrorPopup && (
                  <ErrorInnerPopup
                    modalTitle={""}
                    modalHeader={true}
                    onCloseModal={() => setShowErrorPopup(false)}
                  >
                    <ErrorPopup
                      message={errMessage}
                      onClose={() => setShowErrorPopup(false)}
                    />
                  </ErrorInnerPopup>
                )
              }
              {showCancelledPopup && (
                <CancelledBetDeskonPopup
                  onClose={() => setShowCanclledPopup(false)}
                />
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default withTranslation()(Dasar);
